/**
 * 화씨(°F)를 섭씨(°C)로 변환하는 함수
 * @param {number|string} fahrenheit - 화씨 온도값
 * @param {number|null} [decimals=0] - 소수점 자리수 (기본값: 0, null 지정 시 반올림 없이 전체 소수점 반환)
 * @returns {number|null} 섭씨 온도값 (입력이 유효하지 않은 경우 null)
 */
export const convertToCelsius = (fahrenheit, decimals = 0) => {
  if (fahrenheit === null || fahrenheit === undefined || fahrenheit === "") {
    return null;
  }

  const num = parseFloat(fahrenheit);
  if (isNaN(num)) {
    return null;
  }

  const celsius = (num - 32) / 1.8;

  if (decimals !== null && decimals >= 0) {
    const factor = Math.pow(10, decimals);
    return Math.round(celsius * factor) / factor;
  }

  return celsius;
};

export default convertToCelsius;
